import { useCallback, useEffect, useState } from 'react';
import { listaInstruktioner } from '../instruktionerApi';

// Listan delas mellan biblioteket, hjälpvyn och sidomenyns räknare och hämtas
// en gång per session (den ändras bara vid deploy).
let cache = null;
let pagaende = null;

function hamta() {
  if (!pagaende) {
    pagaende = listaInstruktioner()
      .then((data) => { cache = data; return data; })
      .finally(() => { pagaende = null; });
  }
  return pagaende;
}

/**
 * @returns {{ poster: Array<object>, systemadmin: boolean, laddar: boolean, fel: string|null, laddaOm: () => void }}
 */
export function useInstruktioner() {
  const [data, setData] = useState(cache);
  const [fel, setFel] = useState(null);

  const ladda = useCallback(() => {
    setFel(null);
    hamta().then(setData).catch((e) => setFel(e.message || 'Kunde inte hämta instruktionerna'));
  }, []);

  useEffect(() => { if (!cache) ladda(); }, [ladda]);

  return {
    poster: (data && data.instruktioner) || [],
    systemadmin: !!(data && data.systemadmin),
    laddar: !data && !fel,
    fel,
    laddaOm: () => { cache = null; ladda(); },
  };
}
